module.exports = __webpack_public_path__ + "static/media/transport.c3531466.jpg";